// extracted by mini-css-extract-plugin
export var card = "_s6-0";